/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { withLocalization } from 'hocs/localization'
import { hiddenUnmountedModal } from 'hocs/hiddenUnmountedModal'
import { closeModal } from 'redux-app/modules/modals'
import { getModalDataByName } from 'redux-app/selectors/modals'
import { MODAL_PAYMETRIC_SERVICE_UNAVAILABLE } from './constants'
import PaymetricServiceUnavailableModal from './PaymetricServiceUnavailableModal'

export default compose(
  hiddenUnmountedModal(MODAL_PAYMETRIC_SERVICE_UNAVAILABLE),
  withLocalization('company.card.form.paymetricUnavailable'),
  connect(
    state => {
      const { requestData } = getModalDataByName(state, { name: MODAL_PAYMETRIC_SERVICE_UNAVAILABLE })
      return {
        requestData,
      }
    },
    {
      closeModal,
    },
  ),
  withHandlers({
    onClose: ({ closeModal }) => () => closeModal({ name: MODAL_PAYMETRIC_SERVICE_UNAVAILABLE }),
  }),
)(PaymetricServiceUnavailableModal)
